import React from 'react';
import PropTypes from 'prop-types';

import helperUtils from '../utils/helper.util';
import config from '../config';

export default class BaseTableCompoment extends React.Component {
  displayName = 'BaseGridComponent';

  static propTypes = {
    childDisplayName: PropTypes.string
  };

  static defaultProps = {
    childDisplayName: 'logging'
  };

  constructor(props) {
    super(props);
    // Provides util methods to inherited classes such as constants and helper functions
    this.populateClassWithProperties(helperUtils);
    this.populateClassWithProperties(config);
    this.childDisplayName = props.childDisplayName;
    this.errors = {
      NO_CALLBACK: 'No callback supplied',
      CALLBACK_TYPE: 'Callback is not a function'
    };
    this.BUTTON_TYPES = {
      TEXT: 'text',
      ICON: 'icon'
    };
  }

  getDocumentRemNumberValue = () => {
    const computedFontSize = window.getComputedStyle(
      document.getElementsByTagName('head')[0]
    ).fontSize;
    const fontSizeNumber =
      computedFontSize && computedFontSize.length > 0
        ? parseInt(computedFontSize.split('px')[0], 10)
        : -1;

    return fontSizeNumber;
  };

  log = (str, ...rest) => {
    // eslint-disable-next-line no-console
    console.log(`${this.childDisplayName || 'logging'} - ${str}`, ...rest);
  };

  populateClassWithProperties = props => {
    // eslint-disable-next-line array-callback-return
    Object.keys(props).map(key => {
      if (props[key] && !this[key]) this[key] = props[key];
    });
  };
}
